import { DataRequirements } from '../data.requirements';
import * as i0 from "@angular/core";
import * as i1 from "../data.requirements";
export class CheckMailUseCase {
    constructor(data) {
        this.data = data;
    }
    run(token) {
        return this.data.checkMail(token);
    }
}
CheckMailUseCase.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CheckMailUseCase_Factory() { return new CheckMailUseCase(i0.ɵɵinject(i1.DataRequirementsInjectionToken)); }, token: CheckMailUseCase, providedIn: "root" });
